import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({ name: 'prettyJson' })
export class PrettyJSONPipe implements PipeTransform {
  transform(obj: any) {
    return JSON.stringify(obj, null, 2);
  }
}
